import React from "react";
import { Grid } from "@mui/material";

const LoadingIcon = () => {
  return (
    <Grid container direction='row' justifyContent='center' alignItems='center'>
      <img src={process.env.PUBLIC_URL + "/images/Loading-Icon.gif"} alt='Loading...' />
    </Grid>
  );
};

export default LoadingIcon;
